import React, { useEffect, useRef, useState } from 'react';
import './Level4.css';

import Lvl4Bg from '../Assets/Backgrounds/Lvl4Bg.png';
import Ship from '../Assets/Imgs/Ship.png';

import Rock1 from '../Assets/Imgs/Rock1.png';
import Rock2 from '../Assets/Imgs/Rock2.png';
import Rock3 from '../Assets/Imgs/Rock3.png';
import Rock4 from '../Assets/Imgs/Rock4.png';

import LoseScreen from '../Components/Layout/LoseScreen';
import WinScreen from '../Components/Layout/WinScreen';

const Level4 = () => {
    const rocksPool = [Rock1, Rock2, Rock3, Rock4];


    const SHIP_WIDTH = 172;
    const SHIP_HEIGHT = 187;
    const MOVE_SPEED = 6;
    const SHIP_BOTTOM = 40;

    const INITIAL_SHIP_X = window.innerWidth / 2 - SHIP_WIDTH / 2;

    const [shipX, setShipX] = useState(INITIAL_SHIP_X);
    const [asteroids, setAsteroids] = useState([]);
    const [isDead, setIsDead] = useState(false);
    const [isWon, setIsWon] = useState(false); 


    const shipXRef = useRef(INITIAL_SHIP_X);
    const keysPressed = useRef({});
    const spawnTimer = useRef(0);
    const asteroidIdCounter = useRef(0);
    

    const survivalTimer = useRef(0); 

    const handleRetry = () => {
        keysPressed.current = {};
        spawnTimer.current = 0;
        survivalTimer.current = 0; 
        shipXRef.current = window.innerWidth / 2 - SHIP_WIDTH / 2;
        setShipX(shipXRef.current);
        setAsteroids([]);
        setIsDead(false);
        setIsWon(false);
    };

    useEffect(() => {
        const handleKeyDown = (e) => { keysPressed.current[e.key.toLowerCase()] = true; };
        const handleKeyUp = (e) => { keysPressed.current[e.key.toLowerCase()] = false; };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        let animationFrameId;

        const updateGame = () => {
            if (isDead || isWon) return;

           
            survivalTimer.current += 1 / 60;
            if (survivalTimer.current >= 30) {
                setIsWon(true);
                return;
            }


            let nextX = shipXRef.current;
            if (keysPressed.current['a'] || keysPressed.current['arrowleft']) {
                nextX -= MOVE_SPEED;
            }
            if (keysPressed.current['d'] || keysPressed.current['arrowright']) {
                nextX += MOVE_SPEED;
            }
            
            if (nextX < 0) nextX = 0;
            if (nextX > window.innerWidth - SHIP_WIDTH) nextX = window.innerWidth - SHIP_WIDTH;
            
            shipXRef.current = nextX;
            setShipX(nextX);

            spawnTimer.current += 1;
            if (spawnTimer.current >= 45) {
                const randomImg = rocksPool[Math.floor(Math.random() * rocksPool.length)];
                const randomSize = Math.floor(Math.random() * 40) + 50; 
                const randomX = Math.random() * (window.innerWidth - randomSize);
                const randomSpeed = Math.random() * 2 + 1.5; 

                const newAsteroid = {
                    id: asteroidIdCounter.current++,
                    img: randomImg,
                    x: randomX,
                    y: -randomSize, 
                    size: randomSize,
                    speed: randomSpeed
                };

                setAsteroids((prev) => [...prev, newAsteroid]);
                spawnTimer.current = 0;
            }

            setAsteroids((prevAsteroids) => {
                const updated = [];
                const shipTop = window.innerHeight - SHIP_BOTTOM - SHIP_HEIGHT;
                const shipBottom = window.innerHeight - SHIP_BOTTOM;
                const currentShipX = shipXRef.current;

                for (let i = 0; i < prevAsteroids.length; i++) {
                    const rock = prevAsteroids[i];
                    const nextY = rock.y + rock.speed;

                    const overlapX = (currentShipX + SHIP_WIDTH > rock.x) && (currentShipX < rock.x + rock.size);
                    const overlapY = (shipBottom > nextY) && (shipTop < nextY + rock.size);

                    if (overlapX && overlapY) {
                        setIsDead(true);
                    }

                    if (nextY < window.innerHeight) {
                        updated.push({ ...rock, y: nextY });
                    }
                }
                return updated;
            });

            animationFrameId = requestAnimationFrame(updateGame);
        };

        animationFrameId = requestAnimationFrame(updateGame);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            cancelAnimationFrame(animationFrameId);
        };
    }, [isDead, isWon]);

    return (
        <main className='Level4Main'>
            {!isDead && !isWon && (
                <div className="SurvivalTimerUI">
                    TIME REMAINING: {Math.max(0, Math.ceil(30 - survivalTimer.current))}s
                </div>
            )}

            <div className='Lvl4Bg'>
                <img src={Lvl4Bg} alt="Space Background" />
            </div>

            {asteroids.map((rock) => (
                <div
                    key={rock.id}
                    className='Asteroid'
                    style={{
                        left: `${rock.x}px`,
                        top: `${rock.y}px`,
                        width: `${rock.size}px`,
                        height: `${rock.size}px`
                    }}
                >
                    <img src={rock.img} alt="Asteroid" style={{ width: '100%', height: '100%' }} />
                </div>
            ))}

            <div
                className='Ship'
                style={{
                    left: `${shipX}px`,
                    width: `${SHIP_WIDTH}px`,
                    height: `${SHIP_HEIGHT}px`,
                    bottom: `${SHIP_BOTTOM}px`
                }}
            >
                <img src={Ship} alt="Spaceship" style={{ width: '100%', height: '100%' }} />
            </div>

            {isDead && (
                <div className="LoseScreenContainer">
                    <LoseScreen RetryClick={handleRetry} />
                </div>
            )}

            {isWon && (
                <div className="WinScreenWrapper">
                    <WinScreen RetryClick={handleRetry} LevelPath="/infinite?level=5" />
                </div>
            )}
        </main>
    );
};

export default Level4;